





































































import { SharedState } from "@/common/state";

import SubjectName from "./SubjectName.vue";
import { computed } from "@vue/composition-api";
import Vue from "vue";
import { state } from "../data/state";
import FolderPath from "@/components/transfer/FolderPath.vue";
import { UseModal } from "@/components/root/modal";
import SubFoldersModalVue from "./sub-folders-modal/SubFoldersModal.vue";
export default Vue.extend({
  components: { SubjectName, FolderPath },
  setup() {
    const {
      is_loading_counters,
      current_subject,
      is_watched_subject,
      delete_investigation,
      save_investigation,
    } = state;


  
    
    const remove_or_save = async () => {
      if (is_watched_subject.value) {
        await delete_investigation();
      } else {
        await save_investigation();
      }
    };

    const show_sub_folders = () => {
      const folder_id = current_subject.value.id;
      const folder_name = current_subject.value.name;
      const count = sub_folders_count_display.value;
      const title =
        count === 1
          ? `Subfolder inside "${folder_name}"`
          : `Subfolders inside "${folder_name}"`;

      UseModal().show(SubFoldersModalVue, {
        title,
        folder_id,
      } as any);
    };

    const sub_folders_count_display = computed(() => {
      const count = current_subject.value.sub_folders_count;
      return typeof count === "number" ? count : 0;
    });
    
    return {
      is_loading_counters,
      current_subject,
      remove_or_save,
      is_watched_subject,
      show_sub_folders,
      sub_folders_count_display,
      has_folders_context_poc_open: computed(() =>
        SharedState.FeatureHelper.is_enabled("folders_context_labels")
      ),
    };
  },
});
